import axios from 'axios';
import { BASE_URL } from './constants';

export const getProduct = product => {
    return axios.get(`${BASE_URL}/${product}`);
};
